import { RegisterKind, SummaryDocumentKind } from 'api/common/constants'
import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button, Form } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const { type, hash } = useParams()
  const nextUrl = `/signUpPreRegisterConnector/${type}/${hash}`
  const [isConfirmChecked, setIsConfirmChecked] = React.useState(false)
  const toggleConfirmCheck = () => setIsConfirmChecked(!isConfirmChecked)
  const imageIndices = Array.from({ length: 21 })
  const getImagePath = (index: number): string => {
    return `/assets/electronicSummary/1759199509062-f121a060-4c95-4970-9b32-cd3bd0a94085_${index}.jpg`
  }
  const onNext = () => {
    const formValues = { summaryDocumentKind: SummaryDocumentKind.Electronic }
    navigate(nextUrl, { state: { formValues } })
  }
  React.useEffect(() => {
    if (!hash || (type !== RegisterKind.Invite && type !== RegisterKind.Assignment)) {
      navigate('/login')
    }
  })
  return (
    <>
      <Header title="（電子）概要書面の確認" />
      <main>
        <section className="mx-4 my-5">
          <p>
            下記の画面より概要書面をお読みいただき、内容をご確認ください。すべて読み終えたら、ページ下のボタンを押して次に進んでください。ボタンを押した後に、ご登録いただいたメールアドレス宛に電子書面による概要書面が交付されます。
          </p>
          <h3 className="mt-5 fw-bold">概要書面 AUBEクエストコネクタープラン</h3>
          {imageIndices.map((_, i) => (
            <div className="document-image" key={i}>
              <img src={getImagePath(i + 1)} alt={`概要書面${i + 1}`} className="w-100" />
            </div>
          ))}
          <div className="mt-5">
            <div key={'confirm-check'}>
              <Form.Check className="w-100 mb-5" type="checkbox" id="confirm-check" label="確認しました" onChange={toggleConfirmCheck} />
            </div>
            <Button variant="primary" className="w-100 py-4" disabled={!isConfirmChecked} onClick={onNext}>
              概要書面を確認しました
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
      <style>{`
        .document-image {
          border: 1px solid rgba(204, 204, 204, 1);
          background-color: #fff;
          margin-top: 24px;
          font-weight: 400;
          white-space: nowrap;
          text-align: center;
          line-height: 150%;
          font-family: Roboto, sans-serif;
        }
      `}</style>
    </>
  )
}

export default SceneComponent
